import React, { memo } from 'react';

import styled from 'styled-components';
import { Button } from 'atoms';
import { FormFieldset } from 'organisms/ResumeForm/FormFieldset';
import { Colors, IResumeDate, IResumeFields, Languages } from 'context';
import { IExperienceValues, ResumeExperienceCard } from 'organisms';

export interface IExperienceBlock {
  language: Languages;
  fields: IResumeFields;
  experience: IExperienceValues[];
  onAddExperience: () => void;
  onInputChange: (name: string, value: string | IResumeDate | boolean) => void;
  onRemoveExperience: (id: string) => void;
}

export const ExperienceBlockComponent = memo(
  ({
    language,
    fields,
    experience,
    onAddExperience,
    onRemoveExperience,
    onInputChange,
  }: IExperienceBlock) => (
    <FormFieldset groupTitle={fields.experience.fieldsetTitle}>
      <ItemWrapper>
        {!!experience.length &&
          experience.map((item, index) => (
            <ResumeExperienceCard
              key={item.id}
              language={language}
              fields={fields}
              index={index}
              values={item}
              onRemoveExperience={onRemoveExperience}
              onInputChange={onInputChange}
            />
          ))}
      </ItemWrapper>
      <Button variant="outline" colors={{ borderColor: Colors.gray }} onClick={onAddExperience}>
        {fields.experience.addCompanyButton}
      </Button>
    </FormFieldset>
  ),
);

const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 24px;
`;
